import React from "react";

interface IPHeaderCardIconProps {
  width?: string;
  height?: string;
  className?: string;
  stroke?: string;
}

const IPHeaderCardIcon: React.FC<IPHeaderCardIconProps> = ({
  width = "500",
  height = "200",
  className = "",
  stroke = "#CDE0F8",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 500 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g filter="url(#filter0_f_4288_11674)">
      <path
        d="M238.179 145.232C168.101 149.848 116.259 208.367 99.0968 237.049L109.682 309.422L516.286 216.512L500.876 111.154C496.102 103.595 477.755 102.496 442.561 158.567C398.569 228.656 325.776 139.462 238.179 145.232Z"
        fill="url(#paint0_linear_4288_11674)"
      />
    </g>
    <path
      d="M238.418 155.229C168.34 159.845 116.498 218.364 99.336 247.046L109.921 319.419L516.525 226.509L501.115 121.151C496.341 113.592 477.994 112.493 442.8 168.564C398.808 238.653 326.015 149.459 238.418 155.229Z"
      stroke={stroke}
    />
    <defs>
      <filter
        id="filter0_f_4288_11674"
        x="-39.2032"
        y="-30.8631"
        width="693.79"
        height="478.585"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="69.15" result="effect1_foregroundBlur_4288_11674" />
      </filter>
      <linearGradient
        id="paint0_linear_4288_11674"
        x1="100.016"
        y1="243.335"
        x2="511.409"
        y2="183.163"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D4C8FF" />
        <stop offset="1" stopColor="#ADEFFF" />
      </linearGradient>
    </defs>
  </svg>
);

export default IPHeaderCardIcon;
